import { useEffect, useState } from "react";
import SessionsInProgressCard from "../../../../components/sessions/SessionsInProgressCard";
import { indexLiveSessions } from "../../../../api/endpoints/supervisors/sessions";
import { useQuery } from "react-query";
import SessionModel from "../../../../api/models/SessionModel";
import { showApiErrorMessages } from "../../../../helpers";
import { ApiCommonParams } from "../../../../api/@types/apiTypes";
import { useLocation, useSearchParams } from "react-router-dom";
import Pagination from "../../../../components/pagination/Pagination";
import PlaceHolder from "../../../../components/placeHolder.tsx/PlaceHolder";

type SupervisorSessionsViewProps = {
  page: number;
};

export default function InProgressSessions(props: SupervisorSessionsViewProps) {
  const { page } = props;
  const [currentPage, setCurrentPage] = useState(page);
  const [searchParams, setSearchParams] = useSearchParams();
  const [studentTutorFilter, setStudentTutorFilter] = useState<object>();
  const [statusFilter, setStatusFilter] = useState<object>();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      refetch();
    }, 0);
  }, [studentTutorFilter, statusFilter]);

  useEffect(() => {
    const pathname = location.pathname;
    searchParams.set("tab", "0");
    window.history.replaceState(
      null,
      "",
      `${pathname}?${searchParams.toString()}`
    );
  }, []);

  useEffect(() => {
    const pathname = location.pathname;
    searchParams.set("page", String(currentPage));
    window.history.replaceState(
      null,
      "",
      `${pathname}?${searchParams.toString()}`
    );
  }, [currentPage]);

  const { data: sessions, refetch } = useQuery(
    ["inProgressSessions", currentPage],
    () => {
      let apiParams: ApiCommonParams = {
        pagination: { pageSize: 10, pageNumber: currentPage },
        filters: {
          order_by: "-created_at",
          ...studentTutorFilter,
          status: statusFilter,
        },
      };
      return indexLiveSessions(apiParams);
    },
    {
      keepPreviousData: true,
      select: (response) => {
        let fetchedStudents: SessionModel[] = [];
        if (response.isSuccess) {
          fetchedStudents = SessionModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedStudents, paginationInfo };
      },
    }
  );

  return (
    <div className="w-full px-8 py-6 flex flex-col gap-4">
      <div
        className={`flex flex-col h-full min-w-full w-fit ${
          !!sessions?.data && sessions.data.length > 0 && " ring-gray-300"
        }`}
      >
        {!!sessions?.data &&
          sessions.data.length > 0 &&
          sessions.data.map((session) => (
            <SessionsInProgressCard session={session} key={session.id} />
          ))}
        {!!sessions?.data && sessions.data.length > 0 ? (
          <>
            <div className="sticky bottom-0 mt-10 ">
              <Pagination
                hasNext={!!sessions.paginationInfo?.hasNext}
                hasPrev={!!sessions.paginationInfo?.hasPrev}
                goToPage={(page: number) => setCurrentPage(page)}
                currentPage={sessions.paginationInfo?.currentPageNumber!}
                numberOfPages={sessions.paginationInfo?.pagesCount!}
              />
            </div>
          </>
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <PlaceHolder title="noReadersTitle" />
          </div>
        )}
      </div>
    </div>
  );
}
